import PropTypes from 'prop-types'
import React, { Component } from "react"

import { connect } from "react-redux"
import { withRouter } from "../../components/Common/withRouter"

import * as url from "../../helpers/url_helper"
import { API_URL } from "../../helpers/api_helper";

import {
    apiError,
    loginUser,
    socialLogin,
    appleSocialLogin,
    googleSocialLogin,
    facebookSocialLogin,
} from "../../store/actions"

import logo from "../../assets/images/VeeperLogo.svg"

class Login extends Component {
    constructor(props) {
        super(props)
        const savedEmail = localStorage.getItem("veeperRememberEmail") || ""
        this.state = {
            loginError: null,
            showPassword: false,
            isLoading: false,
            rememberMe: !!savedEmail,
            email: savedEmail,
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    handleValidSubmit(event) {
        event.preventDefault();
        this.setState({ loginError: null, isLoading: true });

        const formData = new FormData(event.target);
        const email = formData.get('email');
        const values = {
            email,
            password: formData.get('password')
        };

        if (this.state.rememberMe) {
            localStorage.setItem("veeperRememberEmail", email);
        } else {
            localStorage.removeItem("veeperRememberEmail");
        }

        fetch(`${API_URL}${url.POST_FAKE_JWT_LOGIN}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                "access-control-allow-origin": "*",
                'Access-Control-Allow-Credentials': 'true',
                "Content-type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(values)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else if (res.status === 401) {
                    throw new Error("Invalid email or password")
                } else {
                    throw new Error(res.statusText)
                }
            })
            .then(resData => {
                const { data: { accessToken } } = resData;
                const token_authorization = `Bearer ${accessToken}`;
                localStorage.setItem("veeperAuthToken", JSON.stringify(token_authorization));
                this.props.loginUser(values, this.props.history);
            }).catch((error) => {
                this.setState({
                    loginError: error.message || "Login failed. Please try again.",
                    isLoading: false,
                })
            });
    }

    componentDidMount() {
        this.props.apiError("")
    }

    render() {
        const { loginError, showPassword, isLoading, rememberMe, email } = this.state
        const errorMsg = loginError || this.props.error

        return (
            <React.Fragment>
                <style>{`
                    * { box-sizing: border-box; }

                    .v-login {
                        min-height: 100vh;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        background: #0f172a;
                    }

                    @media (max-width: 860px) {
                        .v-login { grid-template-columns: 1fr; }
                        .v-login-left { display: none; }
                    }

                    /* ---- Left ---- */
                    .v-login-left {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 64px 56px;
                        position: relative;
                        overflow: hidden;
                    }

                    .v-login-left::before {
                        content: '';
                        position: absolute;
                        inset: 0;
                        background:
                            radial-gradient(ellipse 60% 50% at 10% 90%, rgba(85,110,230,0.18), transparent),
                            radial-gradient(ellipse 50% 40% at 80% 20%, rgba(99,102,241,0.12), transparent);
                        pointer-events: none;
                    }

                    .v-left-brand {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        margin-bottom: 56px;
                        position: relative;
                    }

                    .v-left-brand-icon {
                        width: 38px;
                        height: 38px;
                        border-radius: 10px;
                        background: #556ee6;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .v-left-brand-name {
                        font-size: 1.1rem;
                        font-weight: 700;
                        color: #e2e8f0;
                        letter-spacing: -0.2px;
                    }

                    .v-left-heading {
                        font-size: 2rem;
                        font-weight: 700;
                        color: #f1f5f9;
                        line-height: 1.25;
                        letter-spacing: -0.5px;
                        margin: 0 0 14px;
                        position: relative;
                    }

                    .v-left-desc {
                        font-size: 0.95rem;
                        color: #94a3b8;
                        line-height: 1.6;
                        max-width: 400px;
                        margin: 0 0 48px;
                        position: relative;
                    }

                    .v-left-stats {
                        display: flex;
                        gap: 40px;
                        position: relative;
                    }

                    .v-stat-num {
                        font-size: 1.5rem;
                        font-weight: 700;
                        color: #f1f5f9;
                        line-height: 1;
                    }

                    .v-stat-label {
                        font-size: 0.78rem;
                        color: #64748b;
                        margin-top: 6px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        font-weight: 500;
                    }

                    .v-left-footer {
                        position: absolute;
                        bottom: 40px;
                        left: 56px;
                        font-size: 0.75rem;
                        color: #475569;
                    }

                    /* ---- Right ---- */
                    .v-login-right {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #fff;
                        padding: 48px 32px;
                    }

                    @media (max-width: 860px) {
                        .v-login-right {
                            min-height: 100vh;
                        }
                    }

                    .v-form-box {
                        width: 100%;
                        max-width: 380px;
                    }

                    /* Mobile brand */
                    .v-mobile-brand {
                        display: none;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 40px;
                    }

                    @media (max-width: 860px) {
                        .v-mobile-brand { display: flex; }
                    }

                    .v-mobile-icon {
                        width: 36px;
                        height: 36px;
                        border-radius: 9px;
                        background: #556ee6;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .v-mobile-name {
                        font-size: 1.05rem;
                        font-weight: 700;
                        color: #1e293b;
                    }

                    /* Form */
                    .v-form-title {
                        font-size: 1.5rem;
                        font-weight: 700;
                        color: #0f172a;
                        margin: 0 0 6px;
                        letter-spacing: -0.3px;
                    }

                    .v-form-subtitle {
                        font-size: 0.88rem;
                        color: #64748b;
                        margin: 0 0 32px;
                    }

                    /* Error */
                    .v-error {
                        background: #fef2f2;
                        border: 1px solid #fecaca;
                        border-radius: 8px;
                        padding: 10px 14px;
                        margin-bottom: 24px;
                        display: flex;
                        align-items: flex-start;
                        gap: 8px;
                        font-size: 0.84rem;
                        color: #dc2626;
                        line-height: 1.45;
                    }

                    .v-error i { font-size: 17px; flex-shrink: 0; margin-top: 1px; }

                    /* Field */
                    .v-field { margin-bottom: 20px; }

                    .v-label {
                        display: block;
                        font-size: 0.8rem;
                        font-weight: 600;
                        color: #334155;
                        margin-bottom: 6px;
                    }

                    .v-input-wrap { position: relative; }

                    .v-input {
                        width: 100%;
                        height: 44px;
                        padding: 0 14px;
                        border: 1.5px solid #e2e8f0;
                        border-radius: 8px;
                        font-size: 0.88rem;
                        color: #0f172a;
                        background: #fff;
                        outline: none;
                        transition: border-color 0.15s, box-shadow 0.15s;
                    }

                    .v-input:focus {
                        border-color: #556ee6;
                        box-shadow: 0 0 0 3px rgba(85,110,230,0.12);
                    }

                    .v-input::placeholder { color: #cbd5e1; }

                    .v-input-pw { padding-right: 44px; }

                    .v-pw-btn {
                        position: absolute;
                        right: 0; top: 0;
                        width: 44px; height: 44px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: none;
                        border: none;
                        cursor: pointer;
                        color: #94a3b8;
                        font-size: 18px;
                        transition: color 0.15s;
                    }

                    .v-pw-btn:hover { color: #556ee6; }

                    /* Options */
                    .v-options {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 28px;
                    }

                    .v-check {
                        display: flex;
                        align-items: center;
                        gap: 7px;
                        cursor: pointer;
                    }

                    .v-check input {
                        width: 15px; height: 15px;
                        accent-color: #556ee6;
                        cursor: pointer;
                        margin: 0;
                    }

                    .v-check span {
                        font-size: 0.83rem;
                        color: #475569;
                        user-select: none;
                    }

                    /* Button */
                    .v-btn {
                        width: 100%;
                        height: 44px;
                        border: none;
                        border-radius: 8px;
                        background: #556ee6;
                        color: #fff;
                        font-size: 0.9rem;
                        font-weight: 600;
                        cursor: pointer;
                        transition: background 0.15s;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 7px;
                    }

                    .v-btn:hover:not(:disabled) { background: #4559cc; }
                    .v-btn:disabled { opacity: 0.6; cursor: not-allowed; }

                    .v-spinner {
                        width: 16px; height: 16px;
                        border: 2px solid rgba(255,255,255,0.3);
                        border-top-color: #fff;
                        border-radius: 50%;
                        animation: v-spin 0.5s linear infinite;
                    }

                    @keyframes v-spin { to { transform: rotate(360deg); } }

                    /* Mobile footer */
                    .v-m-footer {
                        display: none;
                        text-align: center;
                        margin-top: 32px;
                        font-size: 0.76rem;
                        color: #94a3b8;
                    }

                    @media (max-width: 860px) {
                        .v-m-footer { display: block; }
                    }
                `}</style>

                <div className="v-login">
                    {/* Left panel */}
                    <div className="v-login-left">
                        <div className="v-left-brand">
                            <div className="v-left-brand-icon">
                                <img src={logo} alt="" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <span className="v-left-brand-name">Veeper</span>
                        </div>

                        <h1 className="v-left-heading">
                            Admin Panel for<br />Shopify Store Management
                        </h1>
                        <p className="v-left-desc">
                            Monitor revenue recovery, manage coupon blocking, and control
                            store configurations from a single dashboard.
                        </p>

                        <div className="v-left-stats">
                            <div>
                                <div className="v-stat-num">99.9%</div>
                                <div className="v-stat-label">Uptime</div>
                            </div>
                            <div>
                                <div className="v-stat-num">24/7</div>
                                <div className="v-stat-label">Monitoring</div>
                            </div>
                            <div>
                                <div className="v-stat-num">Real-time</div>
                                <div className="v-stat-label">Analytics</div>
                            </div>
                        </div>

                        <div className="v-left-footer">
                            &copy; {new Date().getFullYear()} Veeper &middot; Real Life Apps
                        </div>
                    </div>

                    {/* Right panel */}
                    <div className="v-login-right">
                        <div className="v-form-box">
                            <div className="v-mobile-brand">
                                <div className="v-mobile-icon">
                                    <img src={logo} alt="" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                                </div>
                                <span className="v-mobile-name">Veeper</span>
                            </div>

                            <h2 className="v-form-title">Sign in</h2>
                            <p className="v-form-subtitle">Enter your credentials to access the admin panel</p>

                            <form onSubmit={this.handleValidSubmit}>
                                {errorMsg && (
                                    <div className="v-error">
                                        <i className="mdi mdi-alert-circle-outline" />
                                        <span>{errorMsg}</span>
                                    </div>
                                )}

                                <div className="v-field">
                                    <label className="v-label" htmlFor="email">Email</label>
                                    <div className="v-input-wrap">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            className="v-input"
                                            placeholder="admin@veeper.com"
                                            autoComplete="email"
                                            required
                                            defaultValue={email}
                                        />
                                    </div>
                                </div>

                                <div className="v-field">
                                    <label className="v-label" htmlFor="password">Password</label>
                                    <div className="v-input-wrap">
                                        <input
                                            id="password"
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            className="v-input v-input-pw"
                                            placeholder="Enter password"
                                            autoComplete="current-password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="v-pw-btn"
                                            onClick={() => this.setState({ showPassword: !showPassword })}
                                            tabIndex={-1}
                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                        >
                                            <i className={`mdi ${showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}`} />
                                        </button>
                                    </div>
                                </div>

                                <div className="v-options">
                                    <label className="v-check">
                                        <input
                                            type="checkbox"
                                            checked={rememberMe}
                                            onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                                        />
                                        <span>Remember me</span>
                                    </label>
                                </div>

                                <button type="submit" className="v-btn" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <div className="v-spinner" />
                                            Signing in...
                                        </>
                                    ) : (
                                        "Sign In"
                                    )}
                                </button>
                            </form>

                            <div className="v-m-footer">
                                &copy; {new Date().getFullYear()} Veeper &middot; Real Life Apps
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

Login.propTypes = {
    apiError: PropTypes.any,
    error: PropTypes.any,
    history: PropTypes.object,
    loginUser: PropTypes.func,
    socialLogin: PropTypes.func,
    facebookSocialLogin: PropTypes.func,
    googleSocialLogin: PropTypes.func,
    appleSocialLogin: PropTypes.func
}

const mapStateToProps = state => {
    const { error } = state.Login
    return { error }
}

export default withRouter(
    connect(mapStateToProps, { loginUser, apiError, socialLogin, facebookSocialLogin, googleSocialLogin, appleSocialLogin })(Login)
)
